import { Capacitor as CapacitorApp } from "@capacitor/core";
export default {
	loading: false,
	intercomRunning: false,
	platform: CapacitorApp.getPlatform() || "web",
	currentModule:"rides" 
};
